import { Progress } from '@/components'

import { Ordem } from '../domain/ordem'

export function OrdemDetailsCard_Track({ ordem }: { ordem: Ordem }) {
  return (
    <div className="space-y-1 text-xs">
      <Progress value={ordem.entregaProgress} />
      {ordem.entregaDiasRestantes && (
        <div className="flex justify-end">
          {ordem.entregaDiasRestantes > 0 ? (
            <div>{ordem.entregaDiasRestantes} dia(s) restante(s)</div>
          ) : ordem.status === 'FINALIZADO' ? (
            <div>Entregue</div>
          ) : (
            <div>Atrasado</div>
          )}
        </div>
      )}
    </div>
  )
}
